const ID = ':id';

export const REGULATORY_P = 'regulatory';
export const REGULATORY_PF = `/${REGULATORY_P}`;

export const REGULATORY_DASHBOARD_P = 'dashboard';
export const REGULATORY_DASHBOARD_PF = `${REGULATORY_PF}/${REGULATORY_DASHBOARD_P}`;

export const REGULATORY_LIST_P = 'list';
export const REGULATORY_LIST_PF = `${REGULATORY_PF}/${REGULATORY_LIST_P}`;

export const TRANSACTION_ID_P = `transaction/${ID}`;
export const TRANSACTION_ID_PF = `${REGULATORY_PF}/${TRANSACTION_ID_P}`;
export const TRANSACTION_DOCS_P = 'docs';
export const TRANSACTION_DOCS_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_DOCS_P}`;
export const TRANSACTION_HEADER_P = 'header';
export const TRANSACTION_HEADER_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_HEADER_P}`;
export const TRANSACTION_PARTY_P = 'party';
export const TRANSACTION_PARTY_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_PARTY_P}`;
export const TRANSACTION_CARGO_P = 'cargo';
export const TRANSACTION_CARGO_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_CARGO_P}`;
export const TRANSACTION_INVOICES_P = 'invoices';
export const TRANSACTION_INVOICES_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_INVOICES_P}`;
export const TRANSACTION_INVOICE_P = 'invoice';
export const TRANSACTION_INVOICE_PF = `${TRANSACTION_INVOICES_PF}/${TRANSACTION_INVOICE_P}`;
export const TRANSACTION_ITEMS_P = 'items';
export const TRANSACTION_ITEMS_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_ITEMS_P}`;
export const TRANSACTION_ITEM_P = 'item';
export const TRANSACTION_ITEM_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_ITEM_P}`;
export const TRANSACTION_CPC_P = 'cpc';
export const TRANSACTION_CPC_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_CPC_P}`;
export const TRANSACTION_IN_TRANS_P = 'in-trans';
export const TRANSACTION_IN_TRANS_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_IN_TRANS_P}`;
export const TRANSACTION_OUT_TRANS_P = 'out-trans';
export const TRANSACTION_OUT_TRANS_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_OUT_TRANS_P}`;
export const TRANSACTION_SUMMARY_P = 'summary';
export const TRANSACTION_SUMMARY_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_SUMMARY_P}`;
export const TRANSACTION_SUBMISSIONS_P = 'submissions';
export const TRANSACTION_SUBMISSIONS_PF = `${TRANSACTION_ID_PF}/${TRANSACTION_SUBMISSIONS_P}`;




